import {useCallback} from "react";
import {useSelector} from "react-redux";

import {IRPStore} from "../../app/rp_reducer";
import {calculatePriceFromInstalment} from "../../credit_calculator/utils/calculate_price_from_instalment";
import {useResponsiveLinkTarget} from "../../hooks/use_responsive_link_target";
import {useAppDispatch} from "../../store/hooks";
import {useUserPreferencesFilters} from "../../user/hooks/use_user_preferences_filters";
import {ILatestQuery} from "../../utils/latest_query";
import {createOfferLink} from "../helpers/create_offer_link";
import {showOfferModal as showOfferDetailsModalAction} from "../state/offer_modals_slice";
import {IOfferBoxGTMSource} from "../types/IOfferBoxGTMSource";
import {IOfferModalName} from "../types/OfferModalName";
import {IOfferModalOffer} from "../types/OfferModalOffer";
import {IOfferModalState} from "../types/OfferModalState";

const modalName: IOfferModalName = "mainOfferModal";

export const useOfferDetailsActions = () => {
    const dispatch = useAppDispatch();
    const userPreferencesFilters = useUserPreferencesFilters();
    const priceValuesLower = useSelector((state: IRPStore) => state.search.formValues.price.lower);
    const priceValuesUpper = useSelector((state: IRPStore) => state.search.formValues.price.upper);
    const instalment = useSelector((state: IRPStore) => state.search.formValues.instalment);
    const target = useResponsiveLinkTarget();

    const showOfferDetailsModal = useCallback(
        (offer: IOfferModalOffer, latestQuery?: ILatestQuery, gtmSource?: IOfferBoxGTMSource) => {
            dispatch(
                showOfferDetailsModalAction({
                    modalName,
                    offer,
                    offerId: offer.id,
                    filters: getFilters({
                        latestQuery,
                        userPreferencesFilters,
                        instalment,
                        priceValuesLower,
                        priceValuesUpper
                    }),
                    gtmSource
                })
            );
        },
        [priceValuesLower, priceValuesUpper, userPreferencesFilters, instalment, dispatch]
    );

    const showOfferDetailsGeneralHandler = useCallback(
        (params: {offer: IOfferModalOffer; latestQuery?: ILatestQuery; gtmSource?: IOfferBoxGTMSource}) => {
            const {offer, latestQuery, gtmSource} = params;
            if (offer.configuration.pre_sale) {
                const link = createOfferLink(offer);

                if (target === "_blank") {
                    window.open(link);
                } else {
                    window.location.href = link;
                }
            } else {
                showOfferDetailsModal(offer, latestQuery, gtmSource);
            }
        },
        [showOfferDetailsModal, target]
    );

    return {
        showOfferDetailsModal,
        showOfferDetailsGeneralHandler
    };
};

const getFilters = ({
    latestQuery,
    userPreferencesFilters,
    instalment,
    priceValuesLower,
    priceValuesUpper
}: {
    latestQuery?: ILatestQuery;
    userPreferencesFilters: ReturnType<typeof useUserPreferencesFilters>;
    instalment: number;
    priceValuesLower: string;
    priceValuesUpper: string;
}): IOfferModalState["filters"] => {
    if (latestQuery) {
        // Use filters from latestQuery
        return {
            rooms: {
                lower: latestQuery.rooms_0 ? +latestQuery.rooms_0 : "",
                upper: latestQuery.rooms_1 ? +latestQuery.rooms_1 : ""
            },
            area: {
                lower: latestQuery.area_0 || "",
                upper: latestQuery.area_1 || ""
            },
            floor_choices: latestQuery.floor_choices
                ? Array.isArray(latestQuery.floor_choices)
                    ? latestQuery.floor_choices.map(Number)
                    : [Number(latestQuery.floor_choices)]
                : [],
            price: {
                lower: latestQuery.price_0 || "",
                upper: latestQuery.price_1 || ""
            }
        };
    }
    // Use userPreferencesFilters
    return {
        rooms: {
            lower: userPreferencesFilters.rooms_0 ? +userPreferencesFilters.rooms_0 : "",
            upper: userPreferencesFilters.rooms_1 ? +userPreferencesFilters.rooms_1 : ""
        },
        area: {
            lower: userPreferencesFilters.area_0 ? userPreferencesFilters.area_0 : "",
            upper: userPreferencesFilters.area_1 ? userPreferencesFilters.area_1 : ""
        },
        floor_choices: userPreferencesFilters.floor_choices?.map(Number) || [],
        price: {
            lower: instalment ? "" : priceValuesLower || "",
            upper: instalment ? calculatePriceFromInstalment(instalment) : priceValuesUpper || ""
        }
    };
};
import {useCallback} from "react";
import {useSelector} from "react-redux";

import {IRPStore} from "../../app/rp_reducer";
import {calculatePriceFromInstalment} from "../../credit_calculator/utils/calculate_price_from_instalment";
import {useResponsiveLinkTarget} from "../../hooks/use_responsive_link_target";
import {useAppDispatch} from "../../store/hooks";
import {useUserPreferencesFilters} from "../../user/hooks/use_user_preferences_filters";
import {ILatestQuery} from "../../utils/latest_query";
import {createOfferLink} from "../helpers/create_offer_link";
import {showOfferModal as showOfferDetailsModalAction} from "../state/offer_modals_slice";
import {IOfferBoxGTMSource} from "../types/IOfferBoxGTMSource";
import {IOfferModalName} from "../types/OfferModalName";
import {IOfferModalOffer} from "../types/OfferModalOffer";
import {IOfferModalState} from "../types/OfferModalState";

const modalName: IOfferModalName = "mainOfferModal";

export const useOfferDetailsActions = () => {
    const dispatch = useAppDispatch();
    const userPreferencesFilters = useUserPreferencesFilters();
    const priceValuesLower = useSelector((state: IRPStore) => state.search.formValues.price.lower);
    const priceValuesUpper = useSelector((state: IRPStore) => state.search.formValues.price.upper);
    const instalment = useSelector((state: IRPStore) => state.search.formValues.instalment);
    const target = useResponsiveLinkTarget();

    const showOfferDetailsModal = useCallback(
        (offer: IOfferModalOffer, latestQuery?: ILatestQuery, gtmSource?: IOfferBoxGTMSource) => {
            dispatch(
                showOfferDetailsModalAction({
                    modalName,
                    offer,
                    offerId: offer.id,
                    filters: getFilters({
                        latestQuery,
                        userPreferencesFilters,
                        instalment,
                        priceValuesLower,
                        priceValuesUpper
                    }),
                    gtmSource
                })
            );
        },
        [priceValuesLower, priceValuesUpper, userPreferencesFilters, instalment, dispatch]
    );

    const showOfferDetailsGeneralHandler = useCallback(
        (params: {offer: IOfferModalOffer; latestQuery?: ILatestQuery; gtmSource?: IOfferBoxGTMSource}) => {
            const {offer, latestQuery, gtmSource} = params;
            if (offer.configuration.pre_sale) {
                const link = createOfferLink(offer);

                if (target === "_blank") {
                    window.open(link);
                } else {
                    window.location.href = link;
                }
            } else {
                showOfferDetailsModal(offer, latestQuery, gtmSource);
            }
        },
        [showOfferDetailsModal, target]
    );

    return {
        showOfferDetailsModal,
        showOfferDetailsGeneralHandler
    };
};

const getFilters = ({
    latestQuery,
    userPreferencesFilters,
    instalment,
    priceValuesLower,
    priceValuesUpper
}: {
    latestQuery?: ILatestQuery;
    userPreferencesFilters: ReturnType<typeof useUserPreferencesFilters>;
    instalment: number;
    priceValuesLower: string;
    priceValuesUpper: string;
}): IOfferModalState["filters"] => {
    if (latestQuery) {
        // Use filters from latestQuery
        return {
            rooms: {
                lower: latestQuery.rooms_0 ? +latestQuery.rooms_0 : "",
                upper: latestQuery.rooms_1 ? +latestQuery.rooms_1 : ""
            },
            area: {
                lower: latestQuery.area_0 || "",
                upper: latestQuery.area_1 || ""
            },
            floor_choices: latestQuery.floor_choices
                ? Array.isArray(latestQuery.floor_choices)
                    ? latestQuery.floor_choices.map(Number)
                    : [Number(latestQuery.floor_choices)]
                : [],
            price: {
                lower: latestQuery.price_0 || "",
                upper: latestQuery.price_1 || ""
            }
        };
    }
    // Use userPreferencesFilters
    return {
        rooms: {
            lower: userPreferencesFilters.rooms_0 ? +userPreferencesFilters.rooms_0 : "",
            upper: userPreferencesFilters.rooms_1 ? +userPreferencesFilters.rooms_1 : ""
        },
        area: {
            lower: userPreferencesFilters.area_0 ? userPreferencesFilters.area_0 : "",
            upper: userPreferencesFilters.area_1 ? userPreferencesFilters.area_1 : ""
        },
        floor_choices: userPreferencesFilters.floor_choices?.map(Number) || [],
        price: {
            lower: instalment ? "" : priceValuesLower || "",
            upper: instalment ? calculatePriceFromInstalment(instalment) : priceValuesUpper || ""
        }
    };
};
